import { get } from "lodash";

const getPriceKey = (postcodeValue) => {

    if (process.env.DEALER_SITE) {
        const state = get(window, 'staticly.data.SocialFooterLinks.state', null);
        return state ? `priceAU${state}` : 'priceAUNSW' // only dealers in AU
    }

    if (process.env.STATICLY_DEPLOYMENT_DESTINATION_DOMAIN.indexOf('jayco.com.au') !== -1 || window.location.hostname.indexOf('com-au') !== -1 || window.location.hostname.indexOf('com.au') !== -1) {
        const userLocation = localStorage.getItem('userLocation') ? JSON.parse(localStorage.getItem('userLocation')) : null;

        if (postcodeValue || userLocation) {
            const postcode = postcodeValue ? parseInt(postcodeValue) : parseInt(userLocation.postcode);
            if ((postcode >= 1000 && postcode <=1999) || (postcode >= 2000 && postcode <= 2599) || (postcode >=2619 && postcode <= 2899) || (postcode >= 2921 && postcode <= 2999)){
                return 'priceAUNSW';
            } else if ((postcode >= 200 && postcode <= 299) || (postcode >= 2600 && postcode <= 2618) || (postcode >= 2900 && postcode <= 2920)) {
                return 'priceAUACT';
            } else if ((postcode >= 3000 && postcode <= 3999) || (postcode >= 8000 && postcode <= 8999)) {
                return 'priceAUVIC';
            } else if ((postcode >= 4000 && postcode <= 4999) || (postcode >= 9000 && postcode <= 9999)) {
                return 'priceAUQLD';
            } else if ((postcode >= 5000 && postcode <= 5799) || (postcode >= 5800 && postcode <= 5999)) {
                return 'priceAUSA';
            } else if ((postcode >= 6000 && postcode <= 6797) || (postcode >= 6800 && postcode <= 6999)) {
                return 'priceAUWA';
            } else if ((postcode >= 7000 && postcode <= 7799) || (postcode >= 7800 && postcode <=7999)) {
                return 'priceAUTAS';
            } else if ((postcode >= 800 && postcode <= 899) || (postcode >= 900 && postcode <= 999)) {
                return 'priceAUNT';
            }
            return 'priceAUNSW';

        } else {
            return null;
        }
    } else {
        return 'priceNZ'
    }
}

export default getPriceKey